var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { memo } from "react";
const SvgCategoryHandshake = _ref => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 1.524,
    d: "M24.8 48.8c13.255 0 24-10.745 24-24S38.055.8 24.8.8s-24 10.745-24 24 10.745 24 24 24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#081319",
    d: "M39.2 32.4h-4.9V17.5h4.9V19h-3.4v11.9h3.4zM15.2 31.6h-4.9v-1.5h3.4V18.3h-3.4v-1.5h4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#081319",
    d: "M35 29.7h-3v1.5h3zM16 27.8h-1.5v1.5H16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#081319",
    d: "M20.4 35.5c-.2 0-.3 0-.5-.1-.5-.1-.9-.5-1.1-.9l-3-5.3-1-.1.1-1.5 1.8.1 3.4 6 .2.2h.3l.8 1.3c-.3.2-.6.3-1 .3M24.2 35.1c-.7 0-1.3-.3-1.7-1L21 31.5c-.2-.4-.1-.8.3-1s.8-.1 1 .3l1.5 2.7c.1.2.3.2.5.1.4-.2.8-.1 1 .3s.1.8-.3 1c-.2.1-.5.2-.8.2M27.2 34.3c-.7 0-1.3-.3-1.7-1l-2.1-3.6c-.2-.4-.1-.8.3-1s.8-.1 1 .3l2.1 3.6.2.2h.3c.4-.2.8-.1 1 .3s.1.8-.3 1c-.2.1-.5.2-.8.2M30.5 33.3c-.2 0-.3 0-.5-.1-.5-.1-.9-.4-1.1-.9L26 27.9c-.2-.4-.1-.8.2-1.1.4-.2.8-.1 1.1.2l3 4.5.2.2h.3c.3-.2.8-.9 1-1.3s.6-.5 1-.3.5.6.3 1c-.1.2-.8 1.5-1.6 1.9-.3.2-.6.3-1 .3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#081319",
    d: "M34.9 31.4h-3.5L27 22.8l-1.6-.3c-.8 1-2.9 3.1-4.5 3.2s-2.6-1.4-2.6-1.5l-.3-.3.3-.4c.1-.2 3.2-4.5 4-5.4 1-1.1 2.1-1.2 2.2-1.2l5-.1 6.1 2.8-.6 1.5-5.8-2.7-4.6.1c-.1 0-.6.1-1.1.7-.6.6-2.4 3.2-3.6 4.8.2.2.5.4.9.4.9 0 2.7-1.8 3.7-3l.3-.3 3.2.5 4.3 8.4h2.6zM20.5 17.9H14v1.5h5.3q.75-.75 1.2-1.5"
  }))));
};
const Memo = /*#__PURE__*/memo(SvgCategoryHandshake);
export default Memo;